module.exports = __webpack_public_path__ + "img/thumb_12.e9390407.jpg";